import type { ReactNode } from 'react';
import bgGlow from '@/assets/bg-glow.svg';

interface PagePropsType {
  children: ReactNode;
  className?: string;
  center?: boolean;
}

export function Page({
  children,
  className = '',
  center = false,
}: PagePropsType) {
  const centerClasses = center ? 'flex items-center justify-center' : '';

  return (
    <div
      className={`relative w-full min-h-screen mx-auto p-6 ${centerClasses} ${className}`}
      style={{
        backgroundImage: `url(${bgGlow})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {children}
    </div>
  );
}

interface StackPropsType {
  children: ReactNode;
  className?: string;
  gap?: number;
}

export function Stack({ children, className = '', gap = 4 }: StackPropsType) {
  return (
    <div className={`flex flex-col gap-${gap} ${className}`}>{children}</div>
  );
}
